<template>
  <div class="pa-4">
    <div v-if="loading" class="text-center">
      <v-skeleton-loader
        type="list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line">
      </v-skeleton-loader>
    </div>
    <v-card elevation="0" v-if="!loading">
      <v-card-text class="text-center text-h6" v-if="total == 0">
        {{ $t("message.no_notifications") }}
      </v-card-text>
      <div class="pa-2" v-if="notifications" v-allowed="'view_payment_alerts'">
        <v-subheader>
          <v-icon color="primary">mdi-bell-outline</v-icon>
          {{ $t("message.notifications") }}
        </v-subheader>
        <template v-for="(n, index) in notifications">
          <v-list-item three-line :key="index + '_' + n.transactionId + index" @click="viewDetails(n)">
            <v-list-item-content>
              <v-list-item-title v-text="n.title">
              </v-list-item-title>
              <v-list-item-subtitle class="error--text font-weight-bold">
                {{ $t("message." + n.status) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-text="n.user">
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              {{ currency }}{{ n.amount }}
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index + 1 < notifications.length" :key="index"></v-divider>
        </template>
      </div>
    </v-card>
  </div>
</template>
<script>
import Api from "@/services/Api2";

export default {
  components: {
  },
  data() {
    return {
      loading: true,
      total: 0,
      notifications: null,
      currency: '$'
    };
  },
  created() {
    if (this.$store.state.managedAcademy) {
      Api()
        .getWithCache("admins/academy/" + this.$store.state.managedAcademy + "/notifications", {}, 60)
        .then((response) => {
          if (response) {
            this.loading = false;
            this.$store.dispatch("setNotificationsCount", response.totalCount);
            this.total = response.totalCount;
            this.currency = response.currency;
            if (response.totalCount > 0) {
              this.notifications = response.alerts;
            }
          }
        })
        .catch(() => {
          this.showAlert(
            "error",
            this.$t("message.error_generic")
          );
        })
    }
  },
  methods: {
    viewDetails(n) {
      if (n.transactionId)
        this.navigateTo({ name: 'viewtransaction', params: { sessionId: n.transactionId } })
      else if (n.userId)
        this.navigateTo({ name: "viewmember", params: { memberid: n.userId } });
    }
  }
}
</script>

<style scoped></style>